module.exports = __webpack_public_path__ + "img/1.5bc574c6.webp";